import { useLiteSiteStore } from "../store";

export function useCurrentUser() {
  // biome-ignore lint/style/noNonNullAssertion:
  return useLiteSiteStore((state) => state.user!);
}
